import { useState } from 'react';
import SwimmingTemplates from './SwimmingTemplates';
import SwimmingWorkout from './SwimmingWorkout';
import SwimmingHistory from './SwimmingHistory';
import SwimmingDashboard from './SwimmingDashboard';

const TABS = [
  { key: 'workout', label: 'Workout' },
  { key: 'templates', label: 'Templates' },
  { key: 'history', label: 'History & Stats' },
  { key: 'dashboard', label: 'Dashboard' },
];

function SwimmingModule({ getToken, userEmail }) {
  const [tab, setTab] = useState('workout');

  return (
    <div className="Swimming">
      <div className="Swimming-tabs">
        {TABS.map(t => (
          <button
            key={t.key}
            className={`Swimming-tab${tab === t.key ? ' Swimming-tab--active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'workout' && <SwimmingWorkout getToken={getToken} userEmail={userEmail} />}
      {tab === 'templates' && <SwimmingTemplates getToken={getToken} userEmail={userEmail} />}
      {tab === 'history' && <SwimmingHistory getToken={getToken} userEmail={userEmail} />}
      {tab === 'dashboard' && <SwimmingDashboard getToken={getToken} userEmail={userEmail} />}
    </div>
  );
}

export default SwimmingModule;
